const dayIsNowDayAfter = (indexToCheck) => {
    let isAfterResult;
    if (indexToCheck === 2) {
        isAfterResult = true;
    }
    else {
        isAfterResult = false;
    };
    return isAfterResult;
};

export default dayIsNowDayAfter;


// WEBPACK FOOTER //
// ./src/js/containers/ProviderContainer/utils/dayIsNowDayAfter.js